export default "__VITE_ASSET__B2M0qM2y__"